export default {
    Kiosk: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500',
    Home: 'fd7c6330-8b9a-45e2-a1f6-f791db65f5d0',
    Work: '5e94cb81-ab9b-4e82-8b98-721a2d1794df',
    Other:'70c950a2-85ba-4dad-885c-ef04672eb815',
    Courier: '93d79d62-523a-4d4f-851f-6866d38cb340',
    Curbside: '40a40496-1c2a-4f46-b00a-f210d34f24cd',
    Bedside: '7e8e5632-6187-4d9b-9528-adf14825e859',
    Counter: '567c43b9-dd50-4dd0-b293-2f8ebceb035c',
    Return: '9aa3323b-2625-4b8d-b46a-c0df95cd3c16',
    Ready: '21deda25-833f-48d9-b4b7-87f41593b7a0',
    Out_for_Delivery: '01d725b1-8baa-4288-9719-3152edb082d0',
    Delivered: '7c496d5a-0ab5-4987-85b9-102fd8a78d9b',
    Move: '87dee241-7922-43ce-ba9f-fc0ec4eb7830',
    Arrived: 'a830c7eb-183e-4d20-8332-72863131dc32',
    Mail_Order: 'ee98b36c-a0e9-4cc4-a411-6c925ad442b6'
  };



// WEBPACK FOOTER //
// ./src/components/enum/location_type.js